import { last } from 'lib/array/arrayUtils'

export function getFinestLocationSearchUrl(
  relatedTravelItems: Array<App.BreadcrumbItem> | undefined,
): string | undefined {
  const locationCrumbs = relatedTravelItems?.filter(item => item.placeId && item.url)

  if (!locationCrumbs?.length) return undefined

  return last(locationCrumbs).url
}
